import { render } from "./disciplinetest.vue?vue&type=template&id=71c0a8ec&scoped=true&ts=true"
import script from "./disciplinetest.vue?vue&type=script&lang=ts"
export * from "./disciplinetest.vue?vue&type=script&lang=ts"

import "./disciplinetest.vue?vue&type=style&index=0&id=71c0a8ec&scoped=true&lang=scss"

import exportComponent from "D:\\ct-construction-ts-mobile\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71c0a8ec"]])

export default __exports__